import { Component } from '@angular/core';
import { NavParams, ModalController } from 'ionic-angular';

import { MenuService } from '../../../../providers/menu-service';

import { ModulosController } from '../../modulos-controller';
import { UsuarioService } from '../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../providers/gestao-pca-service';
import { AlertService } from '../../../../providers/alert-service';
import { ContabilidadeService } from '../../../../providers/contabilidade-service';
import { ModalNaoSeAplicaPage } from "../../../modais/nao-se-aplica/modal-nao-se-aplica";

import { ModalPreVisualizarContabilidadePage } from '../../../modais/modal-pre-visualizacao/contabilidade/modal-pv-contabilidade';

@Component({
  selector: 'page-resumo-acoes',
  templateUrl: 'resumo-acoes.html',
  providers: [
    ContabilidadeService
  ]
})
export class ContabilidadeResumoAnalisePage extends ModulosController {
  listaAnalises: any[];

  listaSefaz: any = [];
  listaEGE: any = [];

  loading: boolean = true;

  constructor(private contabilidadeService: ContabilidadeService,
    public alertService: AlertService, public usuarioService: UsuarioService,
    public modalCtrl: ModalController, public navParams: NavParams,
    public gestaoPcaService: GestaoPcaService, public menuService: MenuService) {
    super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);
    this.carregarDados();

    this.setModuloId(24);
  }

  carregarDados() {
    if (!this.isJurisdicionado) {
      this.contabilidadeService.obterListaAnalises().subscribe(data => {
        this.listaAnalises = data;

        this.listaAnalises.forEach(x => {
          if (x.idStatusAnalise == 5 || x.idStatusAnalise == 6 || x.idStatusAnalise == 7) {
            x.idStatusAnalise = 11;
            x.dsStatusAnalise = 'Para Consulta';
          }
        });

        this.listaSefaz = this.listaAnalises.filter((x) => x.dsDescricaoAnalise.indexOf("- EGE") == -1);
        this.listaEGE = this.listaAnalises.filter((x) => x.dsDescricaoAnalise.indexOf("- EGE") != -1);

        this.loading = false;
      }, error => {
        console.log("erro: " + error);
        this.loading = false;
      });
    } else {
      this.contabilidadeService.obterListaAnalisesJur().subscribe(data => {
        this.listaAnalises = data;

        this.loading = false;
      }, error => {
        console.log("erro: " + error);
        this.loading = false;
      });
    }
    // this.loading = false;
  }

  redirecionarParaAnalise(analise) {
    analise.cdModulo = this.contabilidadeService.obterIdPaginaContabilidade();
    this.menuService.redirecionarSubPagina(this.contabilidadeService.obterIdPaginaContabilidade(), analise);
  }

  voltarPCA() {
    let idSecaoPaginaGestaoPCA = '964';

    this.menuService.redirecionarPagina(idSecaoPaginaGestaoPCA);
  }

  naoSeAplica(item) {

    this.gestaoPcaService.obterModuloPcaPorPCAPorModulo(this.gestaoPcaService.getPCA().id, 4).subscribe(data => {

      let titulo = "NÃO SE APLICA";
      let modal = this.modalCtrl.create(ModalNaoSeAplicaPage,
        {
          titulo: titulo,
          moduloPca: data,
          IdProcesso: data.moduloPca,
          tipoAnalise: 0,
          jurisdicionado: this.isJurisdicionado,
          isCGE: this.isCGE,
          origemArquivo: "NA",
          origemFilter: 'CONTABILIDADE',
          tipoEntidadeExercicio: 0,
          tipoDocumento: 0
        });
      modal.onDidDismiss(retornoModal => {
        this.carregarDados();
        if (retornoModal && retornoModal.flag) {
        }
      });

      modal.present();

    }, error => {
      console.log("erro ao carregar modulo pca: " + error);
    });

  }

  naoSeAplicaAnalise(item) {

    this.gestaoPcaService.obterModuloAnalise(item.idModuloAnalise).subscribe(data => {

      let titulo = "NÃO SE APLICA";
      let modal = this.modalCtrl.create(ModalNaoSeAplicaPage,
        {
          titulo: titulo,
          moduloAnalise: data,
          IdProcesso: data.moduloAnalise,
          tipoAnalise: 0,
          jurisdicionado: this.isJurisdicionado,
          isCGE: this.isCGE,
          origemArquivo: "NA",
          origemFilter: 'CONTABILIDADE',
          tipoEntidadeExercicio: 0,
          tipoDocumento: 0
        });
      modal.onDidDismiss(retornoModal => {
        this.carregarDados();
        if (retornoModal && retornoModal.flag) {
        }
      });

      modal.present();

    }, error => {
      console.log("erro ao carregar modulo pca: " + error);
    });

  }

  previsualizarCertificado() {

    let modal = this.modalCtrl.create(ModalPreVisualizarContabilidadePage, {});
    modal.onDidDismiss(retornoModal => {
      //retorno da modal
    });
    modal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/modulos/relatorios-contabeis/resumo-acoes/resumo-acoes.ts